import styled from '@emotion/styled';

import { COLOR_TEXT_SECONDARY } from './utils/variables';

export const DescriptionCell = styled.div`
  margin: 0;
  font-size: 13px;
  line-height: 1.45;
  color: ${COLOR_TEXT_SECONDARY};
  white-space: normal;
  min-width: 200px;
`;
